import { ACTIONS } from '@~/actions/ptm-slide-events';

const initialState = {
  ptmSlideIndex: 0,
  rwImageIndex: 0,
  showRwImageModal: false,
  showPTMFeedbackSideModal: false,
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.PTM_SLIDE_CHANGE_EVENT:
      return {
        ...state,
        ptmSlideIndex: payload,
      };

    case ACTIONS.REINITIALIZE_PTM:
      return initialState;

    case ACTIONS.SET_RW_IMAGE_INDEX:
      return {
        ...state,
        rwImageIndex: payload,
      };

    case ACTIONS.SET_SHOW_RW_IMAGE_MODAL:
      return {
        ...state,
        showRwImageModal: payload,
      };

    case ACTIONS.SET_SHOW_PTM_FEEDBACK_SIDE_MODAL:
      return {
        ...state,
        showPTMFeedbackSideModal: payload,
      };

    case ACTIONS.CLEAR_SHOW_PTM_FEEDBACK_SIDE_MODAL:
      return {
        ...state,
        showPTMFeedbackSideModal: initialState.showPTMFeedbackSideModal,
      };

    default:
      return state;
  }
}
